import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../../../API";
import { isAutheticated } from "../../auth/authhelper";
import swal from "sweetalert";
import ClipLoader from "react-spinners/ClipLoader";
import { useHistory, useParams, Link } from "react-router-dom";
import Footer from "../Footer";

export default function EditStaff() {
  const { token } = isAutheticated();
  const { id } = useParams(); // staff id from route
  const [state, setstate] = useState({ name: "", email: "" });
  const [characters, setCharacters] = useState(40);
  const [loading, setLoading] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [permissions, setPermissions] = useState({
    Dashboard: false,
    Videos: false,
    Advertisements: false,
    NetworkChannels: false,
    Team: false,
    Analytics: false,
    Setting: false,

    Channel: false,
    Help: false,
    RegistrationFee: false,
    SubscriptionFree: false,
  });

  const history = useHistory();

  const onCancel = () => {
    history.push("/team");
  };

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  // ✅ Load staff details
  useEffect(() => {
    const fetchStaff = async () => {
      try {
        const res = await axios.get(`${API}/api/staff/admin/getOne/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        console.log("stafff", res)
        if (res.data.success) {
          const staff = res.data.staff;
          setstate({ name: staff.name, email: staff.email });
          // setPermissions(staff.permissions || {});
          setPermissions({
            ...permissions,
            ...(staff.permissions || {})
          });
          setCharacters(40 - staff.name.length);
        } else {
          swal("Oops!", res.data.message || "Team not found", "error");
          history.push("/team");
        }
      } catch (error) {
        swal("Error!", "Failed to fetch Team details", "error");
        history.push("/team");
      }
    };

    fetchStaff();
  }, [id, token, history]);

  const handleChange = (e) => {
    setstate({ ...state, [e.target.name]: e.target.value });
    if (e.target.name === "email") {
      if (!validateEmail(e.target.value)) {
        setEmailError("Please enter a valid email address.");
      } else {
        setEmailError("");
      }
    }
  };

  const handleNameChange = (e) => {
    setstate({ ...state, name: e.target.value });
    setCharacters(40 - e.target.value.length);
  };

  const handlePermissionToggle = (perm) => {
    setPermissions({
      ...permissions,
      [perm]: !permissions[perm],
    });
  };

  const handleSubmit = async () => {
    if (
      state.name.trim() === "" ||
      state.email.trim() === "" ||
      !Object.values(permissions).includes(true)
    ) {
      swal({
        title: "Error",
        text: "Name, Email and at least one permission are required.",
        icon: "error",
        buttons: true,
        dangerMode: true,
      });
      return;
    }

    if (!validateEmail(state.email)) {
      setEmailError("Please enter a valid email address.");
      return;
    }

    setLoading(true);

    try {
      const res = await axios.put(
        `${API}/api/staff/admin/edit/${id}`,
        { name: state.name, email: state.email, permissions },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res.data.success) {
        swal({
          title: "Team Updated!",
          text: "Updated details & permissions have been saved. An email has been sent to the Team member.",
          icon: "success",
          button: "Done",
        }).then(() => {
          history.push("/team");
        });
      } else {
        swal("Oops!", res.data.message || "Something went wrong!", "error");
      }
    } catch (e) {
      swal("Oops!", e.response?.data?.message || "Server error", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          {/* Header */}
          <div className="row">
            <div className="col-12">
              <div className="page-title-box d-flex align-items-center justify-content-between">
                <h4 className="mb-0">Edit Team</h4>
                <div className="page-title-right">
                  <ol className="breadcrumb m-0">
                    <li className="breadcrumb-item">
                      <Link to="/dashboard">SoComOTT</Link>
                    </li>
                    <li className="breadcrumb-item active">Team</li>
                    <li className="breadcrumb-item active">Edit Team</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* Employee Details Section */}
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <h5 className="mb-4 font-weight-bold">Employee Details</h5>
                  <form>
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label className="label-100">Name*</label>
                          <input
                            type="text"
                            name="name"
                            value={state.name}
                            maxLength="40"
                            className="form-control input-field"
                            onChange={handleNameChange}
                            placeholder="Name"
                          />
                          <span>Remaining Characters {characters}</span>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label className="label-100">Email*</label>
                          <input
                            type="email"
                            name="email"
                            value={state.email}
                            className={`form-control input-field ${emailError ? "is-invalid" : ""}`}
                            onChange={handleChange}
                            placeholder="Email"
                          />
                          {emailError && (
                            <span className="text-danger" style={{ fontSize: "13px" }}>
                              {emailError}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          {/* Permissions Section */}
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <h5 className="mb-4 font-weight-bold">Permissions</h5>
                  <div className="row ms-3">
                    {Object.keys(permissions).map((perm) => (
                      <div className="col-md-4 mt-2" key={perm}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={perm}
                          checked={permissions[perm]}
                          onChange={() => handlePermissionToggle(perm)}
                        />
                        <label className="form-check-label ml-2" htmlFor={perm}>
                          {perm}
                        </label>
                      </div>
                    ))}
                  </div>
                  <div className="form-group text-right mt-4">
                    <button
                      onClick={handleSubmit}
                      type="button"
                      className="btn btn-success btn-login waves-effect waves-light mr-3"
                    >
                      <ClipLoader loading={loading} size={18} />
                      {!loading && "Save Changes"}
                    </button>
                    <button
                      onClick={onCancel}
                      type="button"
                      className="btn btn-success btn-cancel waves-effect waves-light mr-3"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
